import Vue from 'vue';
import LinkSocialAccounts from "../components/LinkSocialAccounts";

Vue.component('onboarding-social-networking-integration', {
    components: {LinkSocialAccounts},
    data() {
        return {}
    }
});
